import { elementExists } from "../utils";
import CartAwareProductForm from "./cart-aware-product-form";
const InitCartAwareProductForms = function(){
    const forms = document.querySelectorAll( $selector = '[sh-cart-aware-product-form]' );
    if( elementExists( forms )){
        forms.forEach( function( el ){
            let data = el.dataset
            if( typeof( data.productId ) != 'undefined'){
                try{
                    let product_data = JSON.parse(el.querySelector('.product-json' ).innerHTML)
                    let current_variant = JSON.parse(el.querySelector('.current-variant-json' ).innerHTML)
                    let item = new CartAwareProductForm( product_data  ,current_variant, el  );
                    item.init();
                }catch( $e ){
                    console.log( $e , 'error gettign product-json' );
                }
            }
        })
    }
}
export default InitCartAwareProductForms;